<template>
	<div style="height: 39.5vw" v-if="hidePage">
		<div class="flicker">
			<el-tabs v-model="activeName" @tab-click="handleClick" class="tabline">
				<el-tab-pane label="全部" name="all"> </el-tab-pane>
				<el-tab-pane lazy label="正常" name="normal"> </el-tab-pane>
				<el-tab-pane label="超限" name="overrun"> </el-tab-pane>
				<el-tab-pane label="离线" name="leaveLine"> </el-tab-pane>
			</el-tabs>
			<el-button type="primary" style="height: 40px" @click="closeFicker">{{ closeFickerFlag ? "关闭闪动" : "开启闪动" }}</el-button>
		</div>

		<div v-if="chartListLength == 0" style="width:100%;height:100%;">
			<empty :message="'暂无数据'" :height="300"></empty>
		</div>
		<ul class="f-list flex" :style="activeName == 'all' ? 'height: 19.5vw; overflow: auto' : 'overflow: auto'">
			<!-- :style="activeName=='all'?'height: 19.5vw; overflow: auto':'overflow: auto'" -->
			<!-- firewaring -->
			<li
				:class="['center ', item.ci_num === currentName ? 'picact' : '', item.overrun == 1 ? (closeFickerFlag ? 'firewaring' : '') : '']"
				style="margin-top: 40px"
				v-for="(item, index) of chartList"
				:key="index"
				@click="changeLine(index)"
			>
				<div class="tx-center" :ref="'anit' + index">
					<div :id="'tab' + index" :class="[item.unit.toUpperCase() == 'M' ? 'tab2' : 'tab22']"></div>
					<div class="">{{ item.name }}</div>
					<div class="c-b blod">{{ item.value }}{{ item.unit }}</div>
				</div>
			</li>
			<!-- <div class="topBtn">
        <el-button :disabled="isTopBtnDisabled" @click="handleScroll('up')" size="mini" type="primary">↑</el-button>
        <el-button :disabled="isBotBtnDisabled" @click="handleScroll('down')" size="mini" type="primary">↓</el-button>
      </div> -->
		</ul>
		<!-- <el-button :disabled="isTopBtnDisabled" @click="handleScroll('up')" size="mini" type="primary">向上</el-button>
    <el-button :disabled="isBotBtnDisabled" @click="handleScroll('down')" size="mini" type="primary">向下</el-button> -->

		<div class="" v-if="'all' == activeName">
			<div id="line"></div>
		</div>
	</div>
</template>
<script>
	import echarts from "echarts";
	import { getWater } from "../../api/facility";
	import "echarts-liquidfill";
	import empty from "../../components/empty.vue";

	export default {
		components: {
			empty,
		},
		data() {
			return {
				power: 0,
				waterData: [],
				chartList: [],
				timeList: [],
				list: [],
				currentName: "",
				nowMessage: "",
				warning: false,
				loading: true,
				isTopBtnDisabled: false,
				isBotBtnDisabled: false,
				activeName: "all",
				chartListLength: null,
				closeFickerFlag: true,
				hidePage: false,
			};
		},
		computed: {},
		created() {
			if (this.cpNum) this.getList();
		},

		mounted() {},
		props: ["cpNum"],

		watch: {
			cpNum() {
				this.activeName = "all";
				this.getList();
			},
		},
		methods: {
			// 关闭闪动
			closeFicker() {
				this.closeFickerFlag = !this.closeFickerFlag;
			},
			handleClick(tab, event) {
				console.log(this.activeName);
				this.loading = this.$loading({
					lock: true,
					text: "加载中",
					background: "rgba(0, 0, 0, 0.7)",
				});
				this.$nextTick(() => {
					this.getWater();
				});

				console.log(tab, event);
			},
			// 更改 火警状态
			changeFireStatus(isWaring, item) {
				this.warning = isWaring;
				this.nowMessage = item;
				this.startAnimate(isWaring);
			},
			startAnimate(isWaring) {
				if (!this.chartList.length) {
					console.log("无数据");
					return;
				}
				var indx = null;
				var item = null;
				this.chartList.map((it, ind) => {
					// console.log(this.$refs['anit'+ind])
					this.$refs["anit" + ind][0].className = "tx-center";
					if (it.ci_num == this.nowMessage.address) {
						indx = ind;
						item = it;
						console.log(indx, "this.chartList");
					}
				});

				if (!this.warning) {
					console.log("取消闪动");

					return;
				}

				if (this.warning) {
					console.log("收到报警 准备闪动 ");
					console.log(indx, "indx");
					// setTimeout(() => {
					//     this.$refs['anit'+1][0].className =  this.$refs['anit'+1][0].className+' firewaring'

					// }, 50);

					if (indx >= 0 && item) {
						console.log(this.$refs["anit" + indx]);
						// var divs = document.getElementsByClassName('tx-center')
						setTimeout(() => {
							this.$refs["anit" + indx][0].className = this.$refs["anit" + indx][0].className + " firewaring";
							this.changeLine(indx);
						}, 50);
					}
				}
			},
			getList() {
				this.getWater();
			},
			checkUnit(str) {
				if (str.indexOf("水") > -1) {
					return " m";
				} else if (str.indexOf("末端") > -1 || str.indexOf("压") > -1) {
					return " MPa";
				} else {
					return " m";
				}
			},
			clear() {
				(this.waterData = []), (this.chartList = []), (this.timeList = []), (this.list = []);
			},
			changeLine(index) {
				console.log(this.list);
				console.log(this.chartList);
				var arr = this.list[index].heigh ? this.list[index].heigh : this.list[index].power;
				var name = this.list[index].name;
				this.currentName = this.list[index].ci_num;
				this.lineChart(arr, this.list[index].name, this.list[index].shang, this.list[index].xia, this.list[index].water_height);
			},
			getWater() {
				var cNum = this.cpNum == "ee7a45afdd0540d59efc25eb7f3bde74" ? "fe559562bb2b456b848a545bb5d2eb4a" : this.cpNum;
				getWater({ c_company_num: cNum }).then((res) => {
					console.log(res, "res");
					if (res.power.length) {
						// this.list = res.power;
						this.hidePage = true;
						var arr = [];
						res.power.map((item, index) => {
							var obj = {};

							obj.name = item.name;
							obj.value = item.heigh ? (item.heigh.length ? item.heigh[0].value : 0) : item.power.length ? item.power[0].value : 0;

							obj.unit = item.heigh ? (item.heigh.length ? item.heigh[0].unit : "M") : item.power.length ? item.power[0].unit : "M";
							obj.ci_num = item.ci_num || "";
							obj.value_height = Number(item.shang) || 0;
							obj.xia = Number(item.xia) || 0;
							obj.overrun = item.overrun;
							obj.highest = Number(item.highest) || 0;
							obj.water_height = Number(item.water_height || 0);
							obj.value = obj.value ? Number(Number(obj.value).toFixed(3)) : 0;
							arr.push(obj);
						});
						console.log(arr, "arr");
						if (this.activeName == "all") {
							this.chartList = arr;
							this.list = res.power;
						} else if (this.activeName == "normal") {
							//           arrnormal.filter((item)=>{
							//   console.log(item);
							// })
							let arrnormal = JSON.parse(JSON.stringify(arr)).map((item, index) => {
								console.log(item);
								if (Number(item.overrun) == 0) {
									// console.log('jinlai');
									return item;
								}
							});
							// console.log(arrnormal, "11111");
							arrnormal = arrnormal.filter((item) => item != undefined);
							// 筛除离线

							this.chartList = arrnormal;
						} else if (this.activeName == "overrun") {
							let arrnormal = JSON.parse(JSON.stringify(arr)).map((item, index) => {
								// console.log(item);
								if (Number(item.overrun) == 1) {
									// console.log('jinlai');
									return item;
								}
							});
							// console.log(arrnormal, "overrun");
							arrnormal = arrnormal.filter((item) => item != undefined);

							this.chartList = arrnormal;
						} else if (this.activeName == "leaveLine") {
							let arrnormal = JSON.parse(JSON.stringify(arr)).map((item, index) => {
								// console.log(item);
								if (Number(item.overrun) == 2) {
									// console.log('jinlai');
									return item;
								}
							});
							// console.log(arrnormal, "overrun");
							arrnormal = arrnormal.filter((item) => item != undefined);

							this.chartList = arrnormal;
						}
						this.chartListLength = this.chartList.length;
						console.log(this.chartList, 11111111);
						// console.log(arr);
						setTimeout(() => {
							this.makeChart();
							this.changeLine(0);
						}, 100);
						console.log(this.warning, "this.warning");
						setTimeout(() => {
							this.startAnimate(this.warning);
						}, 80);
						this.loading.close();
					} else {
						this.clear();
						this.makeLine("line");
						this.loading = false;
						this.hidePage = false;
						this.$message.warning("该业务尚未开通，请联系管理员");
						this.isShow = false;
						// this.$route.back()
					}
				});
			},
			lineChart(arr, name, up, down, height) {
				if (arr) {
					// console.log(arr)
					var arr1 = [];
					var arr2 = [];
					var upArr = [];
					var downArr = [];
					var htArr = [];
					var unit = "";
					if (arr.length) {
						arr.map((item, index) => {
							var a = item.time.split(" ");
							var time = a[1].substring(0, 5);
							var value = Number(item.value);
							unit = item.unit;
							arr1.push(value);
							arr2.push(time);
						});
						arr1 = arr1.reverse();
						arr2 = arr2.reverse();
					}

					this.makeLine("line", name, arr1, arr2, up, down, height, unit); // 数值 单位 上限 下限 高度
				} else {
				}

				// console.log(arr2)
			},
			// 下面折线图
			makeLine(id, name, arr1, arr2, up, down, height, unit) {
				echarts.init(document.getElementById(id)).dispose();
				if (!name) {
					return;
				}
				let option = {
					tooltip: {
						trigger: "axis",
						axisPointer: {
							lineStyle: {
								color: "#999",
							},
						},
					},
					// legend: {
					//   data: ["当前数值", "上限", "下限", "总高度"],
					// },
					title: {
						text: name,
					},
					grid: {
						left: "2%",
						right: "4%",
						bottom: "10%",
						top: "20%",
						containLabel: true,
					},
					xAxis: [
						{
							type: "category",
							boundaryGap: false,
							axisLabel: {
								interval: 0,
							},
							axisLine: {
								lineStyle: {
									color: "#999",
								},
							},
							data: arr2,
						},
					],
					yAxis: [
						{
							name: unit.toUpperCase() === "MPA" ? `水压 (${unit})` : `水位(${unit}) `,
							type: "value",

							max: height,
							axisTick: {
								show: false,
							},
							axisLine: {
								lineStyle: {
									color: "#999",
								},
							},
							axisLabel: {
								margin: 10,
								textStyle: {
									fontSize: 14,
								},
							},
							splitLine: {
								lineStyle: {
									color: "#eee",
								},
							},
						},
					],
					dataZoom: [
						{
							start: 0,
							type: "inside",
						},
						{
							type: "slider",
							start: 0,
						},
					],

					series: [
						{
							name: "当前数值",
							label: {
								normal: {
									show: false,
									position: "top",
								},
							},
							type: "line",
							smooth: true,
							lineStyle: {
								normal: {
									width: 1,
								},
							},

							markLine: {
								data: [
									{ yAxis: up, lineStyle: { color: "#FF1D00" } },
									{ yAxis: down, lineStyle: { color: "#FF1D00" } },
									{ yAxis: height, lineStyle: { color: "#1E9DFF" } },
								],
							},

							areaStyle: {
								normal: {
									color: new echarts.graphic.LinearGradient(
										0,
										0,
										0,
										1,
										[
											{
												offset: 0,
												color: "rgba(137, 189, 27, 0.3)",
											},
											{
												offset: 0.8,
												color: "rgba(137, 189, 27, 0)",
											},
										],
										false,
									),
									shadowColor: "rgba(0, 0, 0, 0.1)",
									shadowBlur: 10,
								},
							},
							itemStyle: {
								normal: {
									color: "rgb(137,189,27)",
								},
							},
							data: arr1,
						},
						// {
						//   name: "上限",
						//   label: {
						//     normal: {
						//       show: false,
						//       position: "top",
						//     },
						//   },
						//   type: "line",
						//   symbolSize: 0,

						//   smooth: true,
						//   lineStyle: {
						//     normal: {
						//       width:1,
						//     },
						//   },

						//   itemStyle: {
						//     normal: {
						//       color: "#FF1C0E",
						//     },
						//   },
						//   data: up,
						// },
						// {
						//   name:  "下限",
						//   label: {
						//     normal: {
						//       show: false,
						//       position: "top",
						//     },
						//   },
						//   symbolSize: 0,
						//   type: "line",
						//   smooth: true,
						//   lineStyle: {
						//     normal: {
						//       width: 1,
						//     },
						//   },

						//   itemStyle: {
						//     normal: {
						//       color: "#1A9BFF",
						//     },
						//   },
						//   data: down,
						// },
						// {
						//   name: "总高度",
						//   symbolSize: 0,

						//   label: {
						//     normal: {
						//       show: false,
						//       position: "top",
						//     },
						//   },
						//   type: "line",
						//   smooth: true,
						//   lineStyle: {
						//     normal: {
						//       width:1,
						//     },
						//   },

						//   itemStyle: {
						//     normal: {
						//       color: "#FFBE00",
						//     },
						//   },
						//   data: height,
						// },
					],
				};
				setTimeout(() => {
					echarts.init(document.getElementById(id)).setOption(option);
				}, 300);
			},

			waterType(item) {
				var typeArr = ["压", "末端", "压力"];
				if (typeArr.indexOf(item.name) > -1 || item.unit.toUpperCase() !== "M") {
					return 1;
				} else {
					return 2;
				}
			},

			makeChart(id, name, power) {
				this.chartList.map((item, index) => {
					// console.log(item, 2222222222222222);
					// console.log(item.value_height,'shang');
					var type = this.waterType(item);
					var option =
						type == 2
							? {
									// x轴
									xAxis: {
										show: false, // 不显示
									},
									// y轴
									yAxis: {
										show: false, // 不显示
									},
									tooltip: {
										// trigger: 'axis',
										confine: true,
									},

									grid: {
										top: "21%",
										right: "70",
										bottom: "20%",
										left: 70,
									},
									series: [
										{
											type: "liquidFill",
											data: [item.value / Number(item.water_height) > 0 ? item.value / Number(item.water_height) : null],
											color: ["#45BDFF"],
											radius: "60%",
											outline: {
												show: false,
											},
											backgroundStyle: {
												borderColor: "#156ACF",
												borderWidth: 1,
												shadowColor: "rgba(0, 0, 0, 0.4)",
												shadowBlur: 20,
											},
											shape: "roundRect",
											animationDuration: 1000,
											amplitude: 2, //波浪的起伏缓度
											label: {
												position: ["50%", "50%"],
												formatter: function() {
													return "";
												},
												fontSize: 30,
												color: "#D94854",
											},
										},
										{
											type: "line", // 折线图

											markLine: {
												label: {
													show: false,
													fontSize: 0.1,
												},
												// formatter:'',
												// silent: true, // 不触发鼠标事件
												symbol: "", // 标线两端样式
												lineStyle: {
													// 标线样式
													color: "#f00",
													type: "solid",
												},
												data: [
													{
														// 标线数据
														name: "最大值",
														yAxis: [item.value_height / Number(item.water_height)],
														lineStyle: { color: "green" }, // y 轴
													},
													{
														// 标线数据
														name: "最小值",
														yAxis: [item.xia / Number(item.water_height)], // y 轴
														lineStyle: { color: "red" }, // y 轴
													},
												],
											},
										},
									],
							  }
							: (option = {
									series: [
										{
											type: "gauge",
											startAngle: 180,
											endAngle: 0,
											max: item.value_height,
											splitNumber: 12,
											itemStyle: {
												color: "#58D9F9",
												shadowColor: "rgba(0,138,255,0.45)",
												shadowBlur: 5,
												shadowOffsetX: 2,
												shadowOffsetY: 2,
											},
											progress: {
												show: true,
												roundCap: true,
												width: 18,
											},
											pointer: {
												length: "65%",
												width: 10,
												offsetCenter: [0, "5%"],
											},
											axisLine: {
												roundCap: true,
												lineStyle: {
													width: 18,
												},
											},
											axisTick: {
												splitNumber: 2,
												lineStyle: {
													width: 2,
													color: "#999",
												},
											},
											splitLine: {
												length: 2,
												lineStyle: {
													width: 3,
													color: "#999",
												},
											},
											axisLabel: {
												show: false,
												distance: 10,
												color: "#999",
												fontSize: 13,
											},
											title: {
												show: false,
											},
											detail: {
												backgroundColor: "#fff",
												borderWidth: 0,
												width: "60%",
												lineHeight: 20,
												height: 10,
												offsetCenter: [0, "35%"],
												formatter: function(value) {
													return "{value|" + value.toFixed(3) + "}";
												},
												rich: {
													value: {
														fontSize: 20,
														color: "#777",
													},
												},
											},
											data: [{ value: item.value }],
										},
									],
							  });
					if (type == 2) {
						option.tooltip.formatter = function(param) {
							return `<div>` + `最高值:` + item.value_height + "最低值:" + item.xia + `</div>`;
						};
					}

					echarts.init(document.getElementById(`tab${index}`)).clear();
					echarts.init(document.getElementById(`tab${index}`)).setOption(option);
				});
			},

			// // 滚动效果
			// easeInQuad(curtime, begin, end, duration) {
			//   let x = curtime / duration; //x值
			//   let y = x * x; //y值
			//   return begin + (end - begin) * y; //套入最初的公式
			// },
			// easeOutQuad(curtime, begin, end, duration) {
			//   let x = curtime / duration; //x值
			//   let y = -x * x + 2 * x; //y值
			//   return begin + (end - begin) * y; //套入最初的公式
			// },
			// easeInoutQuad(curtime, begin, end, duration) {
			//   if (curtime < duration / 2) {
			//     //前半段时间
			//     return this.easeInQuad(curtime, begin, (begin + end) / 2, duration / 2); //改变量和时间都除以2
			//   } else {
			//     let curtime1 = curtime - duration / 2; //注意时间要减去前半段时间
			//     let begin1 = (begin + end) / 2; //初始量要加上前半段已经完成的
			//     return this.easeOutQuad(curtime1, begin1, end, duration / 2); //改变量和时间都除以2
			//   }
			// },
			// // 滚动
			// handleScroll(action) {
			//   let menuScroll = document.querySelector('.f-list');
			//   // 每次滚动距离
			//   let dis = 60;
			//   // 滚动时长
			//   let duration = 500;
			//   // 初始距离
			//   let preX = 0;
			//   let startTime = new Date().getTime();
			//   let func = () => {
			//     let nowTime = new Date().getTime();
			//     let t = nowTime - startTime;
			//     // 当时长大于500时，停止滚动
			//     if (t > duration) {
			//       return;
			//     }
			//     let s = this.easeInoutQuad(t, 0, dis, duration);
			//     // 每次滚动距离
			//     let x = s - preX;
			//     preX = s;
			//     if (action === 'up') {
			//       // 向上滚动
			//       menuScroll.scrollTop -= x + 5;
			//     } else if (action === 'down') {
			//       // 向上滚动
			//       menuScroll.scrollTop += x + 5;
			//     }
			//     // 请求滚动
			//     requestAnimationFrame(func);
			//   };
			//   requestAnimationFrame(func);
			// },
		},
	};
</script>
<style scoped lang="scss">
	.picact {
		border: 1px solid blueviolet;
	}
	.tab2 {
		width: 200px;
		height: 200px;
	}
	.tab22 {
		margin-top: 10px;
		width: 190px;
		height: 190px;
	}
	#line {
		height: 19.5vw;
		width: 100%;
	}
	.firewaring {
		div {
			border-radius: 0 !important;
			animation: warningmove 0.3s infinite;
			animation-direction: alternate;
		}
		// animation: warningmove 0.3s infinite;
	}
	@keyframes warningmove {
		from {
			background: #ed1c24;
		}
		to {
			background: #ffb800;
		}
	}
	::v-deep .el-tabs__nav-wrap::after {
		// width: 13vw;
	}
	.tabline {
		display: flex;
		justify-content: flex-start;
	}
	.flicker {
		display: flex;
		justify-content: space-between;
	}
</style>
